import styled from "@emotion/styled";
import { Box, Theme } from "@mui/material";

export const  ArticleNavBar = styled(Box)<{theme: Theme}>((props) => ({
    backgroundColor: "white",
    zIndex: 1000,
    display: 'flex',
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    padding: props.theme.spacing(1)
}));